import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const Styled = styled.span`
  padding: 10px;
  vertical-align: middle;
`;

function ToolButton({ title, onClick, children }) {
  return (
    <Styled onClick={onClick}>
      <Tooltip title={<FormattedMessage id={title} defaultMessage={title} />}>
        {children}
      </Tooltip>
    </Styled>
  );
}

ToolButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any,
};

ToolButton.defaultProps = {
  title: '',
  onClick: () => {},
  children: <div />,
};

export default ToolButton;
